import { render, staticRenderFns } from "./post_status.vue?vue&type=template&id=ae180dda&scoped=true&"
import script from "./post_status.vue?vue&type=script&lang=js&"
export * from "./post_status.vue?vue&type=script&lang=js&"
import style0 from "./post_status.vue?vue&type=style&index=0&id=ae180dda&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae180dda",
  null
  
)

export default component.exports